<template>
       <el-dialog
    title="选择司机"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%" 
  >
   <div class="w-[1440px] mx-auto space-y-8">
      <!-- 双栏容器 -->
      <div class="flex gap-6">
        <!-- 进货渠道 -->
        <main class="bg-white rounded-lg shadow-sm p-6 flex-1 transition-all duration-200 hover:shadow-md">
          <div class="mb-6">
            <div class="relative">
              <input
                v-model="searchText1"
                type="text"
                placeholder="司机"
                  @keyup.enter="handleShipmentSearch1"
                class="w-full h-10 pl-10 pr-4 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
              >
              <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
            </div>
          </div>
  
          <!-- 仓库列表 -->
          <div class="grid gap-3" style="overflow-y: auto;height: 300px;">
            <div
              v-for="item in data1"
              :key="item.user_id"
                @click="choose1(item)"
              class="p-4 border rounded-lg cursor-pointer transition-colors"
              style="max-height:100px;"
              :class="{
                'border-primary bg-blue-50': selectedWarehouseId_r === item.user_id,
                'border-gray-100 hover:border-primary': selectedWarehouseId_r !== item.user_id
              }"
            >
              <div class="flex items-start gap-3">
                <i class="fas fa-warehouse text-primary mt-1 text-lg"></i>
                <div class="flex-1 min-w-0">
                    <!-- <img :src="item.avatarUrl" style="width: 100px;height: 100px;"> -->
                    <h3 class="font-medium truncate">{{ item.nickName }}</h3>
                  <!-- <p class="text-sm text-gray-500 mt-1">类型：{{ item.kmdGrade.name }}</p>-->
                  <p class="text-sm text-gray-500 mt-1">联系方式：{{ item.mobile }}</p> 
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
</el-dialog>
  </template>
  
  <script>
    import DriverApi from '@/api/driver.js';
    import PorductApi from '@/api/product.js';
    export default {
    name: 'App',
    data() {
    return {

            selectedWarehouseId_r:0,
            data1:[],
            searchText1:"",
            user_id:0,
        }
    },
    props:['data','type','open_driver'],

    created(){
        this.dialogVisible = this.open_driver;
        this.getTableList();
    },

    methods: {
         /*获取列表*/
        getTableList() {
        let self = this
        self.loading = true
        let Params = {}
            Params.search = self.searchText1
        DriverApi.userlists(Params, true)
            .then(data => {
            self.loading = false
            self.data1 = data.data

            })
            .catch(error => {
                self.loading = false
            });
        },
        /*关闭弹窗*/
        dialogFormVisible(result) {
          this.$emit('choose1', {
                id:  this.selectedWarehouseId_r,
            });
        },
        cancelFunc(){//取消
            this.dialogFormVisible("error")
        },
        handleShipmentSearch1(){
            this.getTableList();
        },
        choose1(item){
            this.selectedWarehouseId_r = item.user_id
            this.$emit('choose1', {
                id: item.user_id,
            });
        },
        toggleWarehouseDropdown() {
            this.showWarehouseDropdown = !this.showWarehouseDropdown
            this.showLocationDropdown = false
        },
        toggleLocationDropdown() {
            this.showLocationDropdown = !this.showLocationDropdown
            this.showWarehouseDropdown = false
        },
    
    }
    }
    </script>
    <style scoped>
    body {
    min-height: 1024px;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }
    .warehouse-dropdown,
    .location-dropdown {
    max-height: 300px;
    overflow-y: auto;
    }
    </style>
    


// WEBPACK FOOTER //
// src/views/order/order/driver.vue